module.exports = __webpack_public_path__ + "img/ico_logo_gray.392ef6de.svg";